const CONFIG = {
  // BASE_URL: "http://localhost:8081",
  // BASE_URL: "https://www.api.ktig.info",
  // BASE_URL: "http://13.233.117.21:8081",
  BASE_URL: "https://www.api.ktig.org.in",
};

export default CONFIG;
